'use strict'

import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import router from '@/router'
import qs from 'qs'

const config = {
  baseURL: process.env.VUE_APP_API_URL || 'http://localhost:8000',
  timeout: 60 * 1000, // Timeout
  withCredentials: true, // Check cross-site Access-Control,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  },
  paramsSerializer: function (params) {
    return qs.stringify(params, { arrayFormat: 'brackets' })
  }
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    return config
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response
  },
  function(error) {
    if (error.response && error.response.status === 401 && !error.response.request.responseURL.includes('auth/me')) {
      store.dispatch('alert', {
        text: 'User authentication expired! Please sign in again.',
        color: 'error'
      })
      store.dispatch('setLoggedOut')

      router.push({ name: 'login' })
    }

    return Promise.reject(error)
  }
)

Plugin.install = function(Vue) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios
      }
    },
    $axios: {
      get() {
        return _axios
      }
    }
  })
}

Vue.use(Plugin)

export default _axios
